import { lazy } from "react";

// Lazy load all pages for code splitting
export const LazyHome = lazy(() => import("@/pages/public/Home/Home"));
export const LazyProperties = lazy(
  () => import("@/pages/public/Properties/Properties")
);
export const LazyAgents = lazy(() => import("@/pages/public/Agents/Agents"));
export const LazyAbout = lazy(() => import("@/pages/public/About/About"));
export const LazyContact = lazy(() => import("@/pages/public/Contact/Contact"));

// Auth Pages
export const LazyLogin = lazy(() => import("@/pages/auth/Login/Login"));
export const LazyRegister = lazy(
  () => import("@/pages/auth/Register/Register")
);
export const LazyForgotPassword = lazy(
  () => import("@/pages/auth/ForgotPassword/ForgotPassword")
);
export const LazyResetPassword = lazy(
  () => import("@/pages/auth/ResetPassword/ResetPassword")
);
export const LazyActivateAccount = lazy(
  () => import("@/pages/auth/ActivateAccount")
);
export const LazyOTPVerification = lazy(
  () => import("@/pages/auth/OTPVerification/OTPVerification")
);
export const LazyOnboarding = lazy(
  () => import("@/pages/auth/Onboarding/Onboarding")
);

// Property Pages
export const LazyPropertyDetailsPage = lazy(
  () => import("@/pages/property/[id]/PropertyDetails")
);
export const LazyPropertySearch = lazy(
  () => import("@/pages/property/search/PropertySearch")
);

// Agent Pages
export const LazyAgentProfilePage = lazy(
  () => import("@/pages/agent/[id]/AgentProfile")
);

// Dashboard Router
export const LazyDashboardRouter = lazy(
  () => import("@/components/DashboardRouter/DashboardRouter")
);

// Dashboard Pages - Customer
export const LazyDashboard = lazy(
  () => import("@/pages/dashboard/customer/Dashboard/Dashboard")
);
export const LazyCustomerProfile = lazy(
  () => import("@/pages/dashboard/customer/Profile/CustomerProfile")
);
export const LazySavedProperties = lazy(
  () => import("@/pages/dashboard/customer/SavedProperties/SavedProperties")
);
export const LazyCustomerBookings = lazy(
  () => import("@/pages/dashboard/customer/Bookings/CustomerBookings")
);
export const LazyDocuments = lazy(
  () => import("@/pages/dashboard/customer/Documents/Documents")
);
export const LazyDocumentDetails = lazy(
  () => import("@/pages/dashboard/customer/Documents/DocumentDetails")
);
export const LazyHelp = lazy(
  () => import("@/pages/dashboard/customer/Help/Help")
);
export const LazyMyAgent = lazy(
  () => import("@/pages/dashboard/customer/MyAgent/MyAgent")
);
export const LazyCustomerMessages = lazy(
  () => import("@/pages/dashboard/customer/Messages/Messages")
);
export const LazyMessageHistory = lazy(
  () => import("@/pages/dashboard/customer/MessageHistory/MessageHistory")
);
export const LazyMessageSettings = lazy(
  () => import("@/pages/dashboard/customer/MessageSettings/MessageSettings")
);

// Dashboard Pages - Agent
export const LazyAgentOverview = lazy(
  () => import("@/pages/dashboard/agent/Overview/AgentOverview")
);
export const LazyAgentBookings = lazy(
  () => import("@/pages/dashboard/agent/Bookings/AgentBookings")
);
export const LazyAgentLeads = lazy(
  () => import("@/pages/dashboard/agent/Leads/AgentLeads")
);
export const LazyClientPanel = lazy(
  () => import("@/pages/dashboard/agent/ClientPanel/ClientPanel")
);
export const LazyAgentContacts = lazy(
  () => import("@/pages/dashboard/agent/Contacts/AgentContacts")
);
export const LazyAgentAvailability = lazy(
  () => import("@/pages/dashboard/agent/Availability/AgentAvailability")
);
export const LazyAgentTasks = lazy(
  () => import("@/pages/dashboard/agent/Tasks/AgentTasks")
);
export const LazyAgentMessages = lazy(
  () => import("@/pages/dashboard/agent/Messages/Messages")
);
export const LazyAgentCommunication = lazy(
  () => import("@/pages/dashboard/agent/Communication/Communication")
);

// Dashboard Pages - Admin
export const LazyAdminUsers = lazy(
  () => import("@/pages/dashboard/admin/Users/AdminUsers")
);
export const LazyAdminProperties = lazy(
  () => import("@/pages/dashboard/admin/Properties/AdminProperties")
);
export const LazyAdminTours = lazy(
  () => import("@/pages/dashboard/admin/Tours/AdminTours")
);
export const LazyAdminTeamChat = lazy(
  () => import("@/pages/dashboard/admin/TeamChat/AdminTeamChat")
);
export const LazyAdminAlerts = lazy(
  () => import("@/pages/dashboard/admin/Alerts/AdminAlerts")
);
export const LazyAdminSettings = lazy(
  () => import("@/pages/dashboard/admin/Settings/AdminSettings")
);
export const LazyAdminAnalytics = lazy(
  () => import("@/pages/dashboard/admin/Analytics/AdminAnalytics")
);

// Shared Components
export const LazyProtectedRoute = lazy(
  () => import("@/components/common/ProtectedRoute/ProtectedRoute")
);
